// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scatter_plot_link {
    right: 10px;
}

.cliffs_div {
    flex-grow: initial!important;
    justify-content: flex-end;
    flex-wrap: wrap;
}

.cliffs_grid {
   margin: 0!important;
}

.ml-dim-reduction-settings-input i.grok-icon.grok-font-icon-settings {
    font-size: 18px;
    position: absolute;
    height: 28px;
}

.ml-dim-reduction-settings-input i.grok-icon.grok-font-icon-settings:not(.ml-dim-reduction-column-editor-input-root i) {
    left: -20px;
}
.dlg-dimensionality-reduction.ui-form, .dlg-markov-clustering.ui-form, .dlg-markov-clustering.ui-form .ui-form, .dlg-dimensionality-reduction.ui-form .ui-form {
    max-width: unset;
}

.ml-dim-reduction-column-editor-input-root label {
    display: none !important;
}

.dim-reduction-dialog-form > .ui-input-root, .dim-reduction-dialog-form > div > .ui-input-root {
    margin-left: 10px;
}

.ml-dim-reduction-column-editor-input-root input, .ml-dim-reduction-column-editor-input-root select {
    margin-left: 20px !important;
}

h3.ml-dim-reduction-column-editor-input-root {
    margin: 0 !important;
}

.ml-dim-reduction-column-editor-root, .ml-dim-reduction-column-editor-header-root {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px !important;
    width: 700px !important;
}

.ml-dim-reduction-column-editor-column-title {
    text-overflow: ellipsis;
    overflow: hidden;
}

.ml-dim-reduction-column-editor-header-root > h1:not(:first-child) {
    margin-left: 20px !important;
}

.ml-dim-reduction-column-editor-table-root .header > td:not(:first-child) {
    padding-left: 32px;
}`, "",{"version":3,"sources":["webpack://./node_modules/@datagrok-libraries/ml/css/styles.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,eAAe;AACnB;;AAEA;GACG,mBAAmB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".scatter_plot_link {\n    right: 10px;\n}\n\n.cliffs_div {\n    flex-grow: initial!important;\n    justify-content: flex-end;\n    flex-wrap: wrap;\n}\n\n.cliffs_grid {\n   margin: 0!important;\n}\n\n.ml-dim-reduction-settings-input i.grok-icon.grok-font-icon-settings {\n    font-size: 18px;\n    position: absolute;\n    height: 28px;\n}\n\n.ml-dim-reduction-settings-input i.grok-icon.grok-font-icon-settings:not(.ml-dim-reduction-column-editor-input-root i) {\n    left: -20px;\n}\n.dlg-dimensionality-reduction.ui-form, .dlg-markov-clustering.ui-form, .dlg-markov-clustering.ui-form .ui-form, .dlg-dimensionality-reduction.ui-form .ui-form {\n    max-width: unset;\n}\n\n.ml-dim-reduction-column-editor-input-root label {\n    display: none !important;\n}\n\n.dim-reduction-dialog-form > .ui-input-root, .dim-reduction-dialog-form > div > .ui-input-root {\n    margin-left: 10px;\n}\n\n.ml-dim-reduction-column-editor-input-root input, .ml-dim-reduction-column-editor-input-root select {\n    margin-left: 20px !important;\n}\n\nh3.ml-dim-reduction-column-editor-input-root {\n    margin: 0 !important;\n}\n\n.ml-dim-reduction-column-editor-root, .ml-dim-reduction-column-editor-header-root {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin-bottom: 10px !important;\n    width: 700px !important;\n}\n\n.ml-dim-reduction-column-editor-column-title {\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.ml-dim-reduction-column-editor-header-root > h1:not(:first-child) {\n    margin-left: 20px !important;\n}\n\n.ml-dim-reduction-column-editor-table-root .header > td:not(:first-child) {\n    padding-left: 32px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
